<template>
  <v-container>
    <h1 class="headline">Shippop Orders</h1>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="orders"
      class="elevation-1"
      :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
      :rows-per-page-text="$t('Rows per page')"
      v-bind:pagination.sync="paginate"
    >
      <template v-slot:items="props">
        <td>{{ props.item.timestamp | DateFormat('DD MMM YYYY HH:mm a') }}</td>
        <td>{{ props.item.purchase_id }}</td>
        <td>
          <v-chip small disabled color="blue" class="white--text">{{ props.item.status }}</v-chip>
        </td>

        <td>
          <v-btn
            v-if="props.item.status == 'confirm'"
            @click="
              currentPaymentID = props.item.purchase_id
              showPreview = true
            "
            color="primary"
            depressed
          >
            Download
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <div style="height: 60px"></div>
    <preview-shippop-cover
      v-if="showPreview"
      v-model="showPreview"
      :purchase_id="currentPaymentID"
    ></preview-shippop-cover>
  </v-container>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'
import api from '@/api'
import PreviewShippopCover from './PreviewShippopCover.vue'
export default {
  data() {
    return {
      serverUrl: config.serverUrl,
      loading: true,
      orders: [],
      paginate: { sortBy: 'timestamp', descending: true, rowsPerPage: 10 },

      headers: [
        { value: 'timestamp', text: 'Time' },

        { value: 'purchase_id', text: 'Payment id' },
        { value: 'status', text: 'Status' },
        { text: 'Print Cover', sortable: false }
      ],
      currentPaymentID: null,
      showPreview: false
    }
  },
  components: {
    PreviewShippopCover
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    this.loading = true
    try {
      var response = await this.shippopbookingrefno()
      if (response.responsecode == 200) {
        this.orders = response.data
      }
    } catch (error) {}
    this.loading = false
  },
  methods: {
    shippopbookingrefno() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.shippopbookingrefno({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Shippop.vue